import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoGallery from './components/VideoGallery';
import Footer from './components/Footer';
import About from './pages/About';
import Contact from './pages/Contact';
import SEO from './components/SEO';
import { agent } from './config/agents';
import { seoConfig } from '../seo.config';

const Home = () => (
  <>
    <SEO 
      title={seoConfig.home.title}
      description={seoConfig.home.description}
      keywords={seoConfig.home.keywords}
    />
    <Header agent={agent} />
    <main className="flex-grow">
      <Hero agent={agent} />
      <VideoGallery />
    </main>
    <Footer agent={agent} />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-white">
          <Helmet>
            <link rel="icon" href="/favicon.ico" sizes="any" />
            <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
            <link rel="manifest" href="/site.webmanifest" />
          </Helmet>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About agent={agent} />} />
            <Route path="/contact" element={<Contact agent={agent} />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;